
export const ENV = {
  BASE_PATH: `https://server-retbot.onrender.com/`,
  BASE_API: `https://server-retbot.onrender.com/api/v1/`,
  BASE_PATH_PAGWEB: "https://retbot.netlify.app/",
  BASE_PATH_LOCALH: "http://localhost:3000/",
  API_ROUTES: {
    REGISTER: "auth/register",
    LOGIN: "auth/login/",
    REFRESH_ACCESS_TOKEN: "auth/refresh_access_token",
    USER_ME: "user/me",
    USER: "user",
    USERS: "users",
    MENU: "menu",
    COURSE: "course",
    NEWSLETTER: "newsletter",
    POST: "post",
    MESSAGE: "message",
  },
  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
};
